import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import Tooltip from '@material-ui/core/Tooltip';
import wrap from 'wraptile';
import {nanoid} from 'nanoid';

import UsersContainer, {UserValue} from '@pluto/users';
import {
    AssignDialogProps,
    QCJobItemModified,
} from '../../QCManagerTypes';
import './AssignDialog.scss';

export const getSelectedJobsNames = (data: QCJobItemModified[], checkedItems: number[]) => {
    const selectedJobNamesArr = data.filter((item) => checkedItems.includes(item.id)).map((job) => job.title);
    
    return (
        <ul className="jobs-names-list">
            {selectedJobNamesArr.map((name) => {
                return <li key={nanoid()}>{`- ${name}`}</li>;
            })}
        </ul>
    );
};

export const getItemText = (selectedItemsLength: number) => {
    let itemLabel = 'items';
    
    if (selectedItemsLength === 1) {
        itemLabel = 'item';
    }
    
    return `${selectedItemsLength} ${itemLabel}`;
};

export const getJobName = (data: QCJobItemModified[], singleItemId: number | undefined) => {
    const job = data.find((item) => item.id === singleItemId) || {} as QCJobItemModified;
    
    return job.title;
};

export const getAdditionalInfo = (selectedItemsLength: number, tooltipTitle: JSX.Element, singleJobName: string | undefined) => {
    if (selectedItemsLength)
        return (
            <>
                <div className="additional-info__job-items">
                    {getItemText(selectedItemsLength)}
                </div>
                <Tooltip
                    className="jobs-items__tooltip"
                    placement="right-start"
                    title={tooltipTitle}
                >
                    <ErrorIcon
                        fontSize="small"
                    />
                </Tooltip>
            </>
        );
    return (
        <div className="additional-info__job-items">
            {singleJobName}
        </div>
    );
};

export const onCloseClick = wrap((onChange: (value: UserValue) => void) => {
    onChange(null);
});

const AssignDialog = (props: AssignDialogProps) => {
    const {
        data,
        open,
        isAssigned,
        handleAssignClose,
        handleUserAssign,
        handleSelectChangeAssign,
        assignedUser,
        checkedItems = [],
        singleItemId,
    } = props;
    
    const singleJobName = getJobName(data, singleItemId);
    const selectedItemsLength = checkedItems.length;
    const tooltipTitle = getSelectedJobsNames(data, checkedItems);
    const additionalInfo = getAdditionalInfo(selectedItemsLength, tooltipTitle, singleJobName);
    
    return (
        <div>
            <Dialog
                onClose={handleAssignClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                className="assign-dialog-modal"
            >
                <MuiDialogTitle
                    id="customized-dialog-title"
                    disableTypography
                    className="dialog__root"
                >
                    <Typography variant="h6">
                        Set assignee
                    </Typography>
                    <IconButton
                        aria-label="close"
                        className="close-button"
                        onClick={handleAssignClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </MuiDialogTitle>
                <div className="assign-dialog-modal__additional-info">
                    <div className="additional-info__job-items-wrapper">
                        Item: {additionalInfo}
                    </div>
                    <div className="assigned-to">
                        Assigned to: {assignedUser ? assignedUser.email : '- -'}
                        {assignedUser?.email && (
                            <CloseIcon
                                className="close-icon"
                                onClick={onCloseClick(handleSelectChangeAssign)}
                            />
                        )}
                    </div>
                </div>
                <UsersContainer
                    assignedUser={assignedUser}
                    onChange={handleSelectChangeAssign}
                />
                <MuiDialogActions>
                    <div className="dialog__actions">
                        <Button
                            onClick={handleAssignClose}
                            className="cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleUserAssign}
                            disabled={!isAssigned}
                            className="save"
                        >
                            Save
                        </Button>
                    </div>
                </MuiDialogActions>
            </Dialog>
        </div>
    );
};

export default AssignDialog;
